<template>
  <v-card
    :loading="loading"
    elevation="0"
    tile
    dark
    color="primary"
    v-if="banner.active"
  >
    <v-row justify-center v-if="loading">
      <v-progress-circular
        :size="55"
        :width="4"
        indeterminate
        dark
        class="mt-4 mb-4 mx-auto"
      ></v-progress-circular>
    </v-row>

    <div v-if="!loading">
      <v-row class="ml-2 mr-2">
        <div v-if="currentStage == stageEnum.INFO">
          <v-card-title>
            {{
              $t("components.banners.kycBanner.appAccessVerificationNeeded")
            }}</v-card-title
          >
          <v-card-text class="mr-2">
            <p>
              {{
                $t(
                  "components.banners.kycBanner.aUserWithEmailGetuserHasTriedToRegisterThisBoatInTheMobileApp",
                  { user: getUser }
                )
              }}
            </p>
            <p>
              {{
                $t(
                  "components.banners.kycBanner.pleaseReviewTheUsersUploadedDocumentationToConfirmSufficientProofOfOwnershipOfTheBoat"
                )
              }}
            </p>
            <p>
              {{
                $t(
                  "components.banners.kycBanner.asSoonAsAccessIsConfirmedTheOwnerWillBeAbleToAccessTheBoatsDataDocumentsMaintenanceForecastsEtcThroughTheMobileApp"
                )
              }}
            </p>
          </v-card-text>

          <v-card-subtitle class="mt-0 pt-0">
            {{ $t("components.banners.kycBanner.essentialBoatInformation") }}
          </v-card-subtitle>

          <v-card-text>
            <i18n
              path="components.banners.kycBanner.beforeMovingForwardPleaseMakeSureThatAllTheEssentialBoatDataIsCompletedEnterToCompleteThisStep"
              tag="p"
            >
              <template v-slot:editMode>
                <a
                  style="color: white; text-decoration: underline"
                  @click="handleEditMode()"
                >
                  {{ $t("components.banners.kycBanner.editMode") }}</a
                >
              </template>
            </i18n>

            <v-checkbox
              v-model="banner.slot_number"
              :label="$t('components.banners.kycBanner.slotNumber')"
              hide-details
              disabled
            >
            </v-checkbox>
            <v-checkbox
              v-model="banner.responsive_dealer"
              :label="$t('components.banners.kycBanner.servicingPartner')"
              hide-details
              disabled
            >
            </v-checkbox>
            <v-checkbox
              v-model="banner.delivery_date"
              :label="$t('components.banners.kycBanner.deliveryDateToCustomer')"
              hide-details
              disabled
            >
            </v-checkbox>

            <p class="mt-4">
              {{
                $t(
                  "components.banners.kycBanner.asASuggestionYouMightAlsoWantToReviewTheBoatsPartsInventoryAndManualsToEnhanceTheUsersExperience"
                )
              }}
            </p>
          </v-card-text>

          <v-card-subtitle class="mt-0 pt-0 pb-5">
            {{ $t("components.banners.kycBanner.documentationUploadedByUser") }}
          </v-card-subtitle>

          <v-card-text>
            <div v-for="(doc, index) in getDocuments" :key="index">
              <div v-for="(file, idx) in doc.file_resources" :key="idx">
                <a :href="file.link" target="_blank" style="color: white">
                  <v-icon class="mr-2"> mdi-image-outline </v-icon
                  ><span> {{ doc.title }} </span>
                </a>
              </div>
            </div>
          </v-card-text>

          <v-card-subtitle class="mb-0 pb-1">
            {{ $t("components.banners.kycBanner.hinConfirmation") }}
          </v-card-subtitle>

          <v-card-text class="mb-6 pt-0">
            <v-checkbox
              v-model="vaildHin"
              :label="
                $t('components.banners.kycBanner.iConfirmTheBoatsHINIsValid')
              "
              hide-details
            >
            </v-checkbox>
          </v-card-text>
          <div v-if="previousUser">
            <v-card-subtitle class="mb-4 pt-0 pb-0">
              <v-icon class="mb-1 mr-1">mdi-alert</v-icon>
              {{ $t("components.banners.kycBanner.changeOfOwnership") }}
            </v-card-subtitle>

            <v-card-text class="mr-2">
              <p>
                {{
                  $t(
                    "components.banners.kycBanner.approvalOfThisKYCRequestWillAlsoTransferTheBoatFromTheExistingUsertoTheNewUser",
                    { prevUser: previousUser, newUser: getUser }
                  )
                }}
              </p>
              <div v-if="this.isLite === false">
                <p>
                  {{
                    $t(
                      "components.banners.kycBanner.theOldUserWillKeepAccessToHistoricalTripData"
                    )
                  }}
                </p>
                <p>
                  {{
                    $t(
                      "components.banners.kycBanner.theNewUserWillNotBeAbleToAccessThisBoatsHistoricalData"
                    )
                  }}
                </p>
              </div>
              <v-checkbox
                v-model="vaildWarning"
                :label="
                  $t(
                    'components.banners.kycBanner.iUnderstandTheImplicationsOfChangingTheBoatsOwner'
                  )
                "
              >
              </v-checkbox>
            </v-card-text>
          </div>
        </div>
        <div v-if="currentStage == stageEnum.CONFIRMATION">
          <v-card-title>
            {{ $t("components.banners.kycBanner.areYouSure") }}
          </v-card-title>
          <v-card-text class="mr-2">
            {{
              $t(
                "components.banners.kycBanner.onlyConfirmAppAccessForTheUserIfTheyHaveSubmittedSufficientProofOfOwnershipFollowingConfirmationAllUserUploadedDocumentsWillBeRemovedYouAreRequiredToDeleteAnyCopiesOfTheUsersDocumentsThatWereUploadedForValidationPurposesOnly"
              )
            }}
          </v-card-text>
        </div>
        <div v-if="currentStage == stageEnum.REJECTION">
          <v-card-title>
            {{ $t("components.banners.kycBanner.areYouSure") }}
          </v-card-title>
          <v-card-text class="mr-2">
            {{
              $t(
                "components.banners.kycBanner.ifTheUserFailsToProvideAdequateOwnershipProofYouShouldRejectTheirAppAccessRequestThisActionWillEraseAllUserUploadedDocumentsYouAreAlsoRequiredToDeleteAnyDownloadedCopiesOfTheUsersDocumentThatWereUploadedSolelyForVerificationPurposes"
              )
            }}
          </v-card-text>
        </div>
      </v-row>
      <v-row justify="end" class="mr-2 pb-1">
        <div v-if="currentStage == stageEnum.INFO">
          <v-row class="mr-1">
            <v-btn dark @click="computeStage(stageEnum.REJECTION)" text>
              {{ $t("components.banners.kycBanner.decline") }}
              <!-- Decline -->
            </v-btn>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    :disabled="!getIsValid"
                    @click="computeStage(stageEnum.CONFIRMATION)"
                    text
                  >
                    {{ $t("components.banners.kycBanner.confirmAccess") }}
                  </v-btn>
                </div>
              </template>
              <span>
                {{
                  $t(
                    "components.banners.kycBanner.toConfirmAccessPleaseMeetAllRequirements"
                  )
                }}
              </span>
            </v-tooltip>
          </v-row>
        </div>
        <div v-if="currentStage == stageEnum.CONFIRMATION">
          <v-btn dark @click="computeStage(stageEnum.INFO)" text>
            {{ $t("components.banners.kycBanner.cancel") }}
          </v-btn>
          <v-btn dark @click="approve" text>
            {{ $t("components.banners.kycBanner.confirmAccess") }}
          </v-btn>
        </div>

        <div v-if="currentStage == stageEnum.REJECTION">
          <v-btn dark @click="computeStage(stageEnum.INFO)" text>
            {{ $t("components.banners.kycBanner.cancel") }}
          </v-btn>
          <v-btn dark @click="reject" text>
            {{ $t("components.banners.kycBanner.rejectAccess") }}
          </v-btn>
        </div>
      </v-row>
    </div>
  </v-card>
</template>
<script>
import api from "@/utils/api";

export default {
  components: {},
  props: {
    banner: {
      type: Object,
      default: Object,
    },
    previousUser: {
      type: String,
    },
    isLite: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      currentStage: null,
      vaildHin: false,
      vaildWarning: false,
    };
  },
  created() {
    this.stageEnum = Object.freeze({
      INFO: "INFO",
      CONFIRMATION: "CONFIRMATION",
      REJECTION: "REJECTION",
    });
    this.currentStage = this.stageEnum.INFO;
  },

  computed: {
    getUser() {
      if (this.banner.content == null) {
        console.error("KYC: Banner content is null");
        return "";
      }
      return this.banner.content.user_email;
    },
    getDocuments() {
      if (this.banner.content == null) {
        console.error("KYC: Banner content is null");
        return "";
      }
      if (this.banner.content.documents == null) {
        console.error("KYC: Banner content documents is null");
        return this.$t("components.banners.kycBanner.noDocumentsUploaded");
      }

      return this.banner.content.documents;
    },
    getIsValid() {
      return (
        this.banner.slot_number &&
        this.banner.responsive_dealer &&
        this.banner.delivery_date &&
        this.vaildHin &&
        (this.vaildWarning || !this.previousUser)
      );
    },
  },
  methods: {
    handleEditMode() {
      this.$router.push({
        name: "boatsEdit",
        params: { id: this.$route.params.id },
      });
    },
    approve() {
      this.loading = true;
      api
        .approveKYCRequest(this.$route.params.id)
        .then((response) => {
          this.loading = false;
          this.$emit("close", "approve");
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("close", "reload");
        });
    },
    reject() {
      this.loading = true;
      api
        .rejectKYCRequest(this.$route.params.id)
        .then((response) => {
          this.loading = false;
          this.$emit("close", "reject");
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("close", "reload");
        });
    },
    computeStage(nextStage) {
      if (nextStage == null) {
        this.currentStage = this.stageEnum.INFO;
        return;
      }
      this.currentStage = nextStage;
      this.$nextTick(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      });
    },
  },
};
</script>
<style scoped>
.v-card__text,
.v-card__title {
  word-break: normal;
}
</style>
